export default __webpack_public_path__ + "static/media/slider-2.673a27a3.jpg";